import React from 'react';
import { Alert, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

function AuditDiff({ diff }: any) {
  const previousVersion = Array.isArray(diff) && diff[0];
  const newVersion = Array.isArray(diff) ? diff[1] : diff;

  // if the diff is an array it means it's a before and after
  return (
    <Box
      component="span"
      sx={{
        mt: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      {previousVersion && (
        <Alert severity="error" icon={false} component="span">
          <strong>
            <FormattedMessage id="POSTS.AUDITS.MODAL.BEFORE" />
          </strong>
          <br />

          {previousVersion}
        </Alert>
      )}
      {newVersion && (
        <Alert severity="success" icon={false} component="span">
          <strong>
            <FormattedMessage id="POSTS.AUDITS.MODAL.AFTER" />
          </strong>
          <br />

          {newVersion}
        </Alert>
      )}
    </Box>
  );
}

export default AuditDiff;
